import './oneZaim.scss';

const OneZaim = ({dat}) => {
    const gtag_report_conversion = (url) => {
        var callback = function () {
            if (typeof(url) !== 'undefined') {
                window.open(dat.order, '_blank');
            }
        };
        window.gtag('event', 'conversion', {
            'send_to': 'AW-11521301823/afxVCPLt7fwZEL-65PUq',
            'event_callback': callback,
        });
        return false;
    };
    return (
        <div className="oneZaim">
                <div className="oneZaim__wrapper">
                    <div className="oneZaim__wrapper-img">
                        <img src={dat.screen} alt="screen" />
                    </div>
                    <div className="oneZaim__wrapper-name">
                        <h2>{dat.name}</h2>
                    </div>
                    <div className="oneZaim__wrapper-money">
                        <h2>{dat.summMid} {dat.summMax} {dat.summPostfix}</h2>
                    </div>
                    {/* <div className="oneZaim__wrapper-percent">
                        <h2>{dat.percentPrefix} {dat.percent} {dat.percentPostfix}</h2>
                    </div> */}
                    <a 
                    href={dat.order} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    onClick={(e) => {
                        e.preventDefault(); // предотвращаем переход по ссылке
                        gtag_report_conversion(dat.order); // вызываем конверсию
                    }}
                    >
                        {dat.orderButtonText}
                    </a>
                </div>
        </div>
    )
}

export default OneZaim;